import { Container } from '@mui/material'
import { ChevronRight } from 'react-feather'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import TableMui from 'src/components/TableMui'
import TextFieldMui from 'src/components/TextFieldMui'
import { State } from 'src/features/types'
import { actions } from '../../BasicQueriesState'
import { BatchInfo as BatchInfoModel } from '../../BasicQueriesTypes'
import { BasicQueriesHeader } from '../../components/Header/Header'
import { ProductInfoCard } from '../../components/ProductInfoCard/ProductInfoCard'
import { Form, Inline } from './BatchInfo.styles'

interface FormType{
  batch: string
}

export const BatchInfo = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const batchInfo = useSelector((state: State) => state.basicQuery.batchInfo)
  const { register, handleSubmit, formState: { errors } } = useForm<FormType>({ defaultValues: { batch: batchInfo?.idBatch.toString() ?? '' } })

  const onSubmit = (data: FormType) => {
    dispatch(actions.getAddressByBatch({ batch: data.batch }))
  }

  const onRowClick = (address: BatchInfoModel['addresses'][0]) => {
    history.push(`/basic-queries/batch-info/${batchInfo?.idBatch}/address/${address.addressFormated}`)
  }

  return (
    <Container>
      <BasicQueriesHeader title='Informações do Lote'/>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <TextFieldMui
          inputProps={{ ...register('batch', { required: true }) }}
          error={!!errors.batch}
          name='batch'
          label='batch'
          testId='batch'
          variant='outlined'
          autoFocus
          fullWidth
        />
      </Form>
      {
        batchInfo && (
          <>
            <ProductInfoCard
              description={batchInfo.productDescription}
              idModel={batchInfo.idModel}
              productCode={batchInfo.productCode}
            />
            <TableMui
              flatTable
              columns={[
                { id: 'addressFormated', label: 'Endereços' },
                { id: 'quantity', label: 'Estoque' },
              ]}
              rows={batchInfo.addresses.map(((item) => ({ ...item, quantity: <Inline>{item.quantity} <ChevronRight/> </Inline> })))}
              onRowClick={onRowClick}
            />
          </>
        )
      }

    </Container>
  )
}
